<fieldset>
	<br/>
	<app-line-other-income *ngFor="let income of incomesFormArray.controls; let i=index" [index]="i" [income]="income" [type]="incomeTypes"
	 (removed)="incomesFormArray.removeAt($event)" [qID]="qID" [displayErrors]="displayErrors" [titles]="titles"  [needSources]="needSources" (change)="emitIncomesChanges($event)"
	 [ph]="ph" [displayX]="incomesFormArray.length>1">
	</app-line-other-income>
</fieldset>

<div class="d-flex justify-content-center text-center">
	<div *ngIf="incomesFormArray.length > 0 && incomesFormArray.length < maxIncomesArrayLength" class="m-add-line-btn" (click)="addIncome()" 
		role="button" tabindex="0" 
		(keypress)="simulateClick($event)">
		<span>{{buttons[1]|translate}}</span>
	</div>
	<div *ngIf="incomesFormArray.length === 0" 
	class="m-add-line-btn" (click)="addIncome()" 
	role="button" tabindex="0" 
	(keypress)="simulateClick($event)">
		<i class="fa fa-plus" aria-hidden="true"></i>
		<span>{{buttons[0]|translate}}</span>
	</div>
</div>
<br/>


// WEBPACK FOOTER //
// ./src/app/incomes-array/incomes-array.component.html